import type { Resource } from '../../';
export const country_countries_CY: Resource = {"default":"Cyprus"};
